export default __webpack_public_path__ + "static/facebook-581a708097ae186f327f173b41561ccd.svg";